import script from "./MarcarChegada.vue?vue&type=script&setup=true&lang=js"
export * from "./MarcarChegada.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__